import * as _ from "lodash";

import { ExtensionBase } from "../extensionBase";
import { viewerOptions } from "../../viewer";
import { GfxUtils } from "../../common/gfxUtils";
import { UiUtils } from "../../common/uiUtils";
import { CommentPanel } from "./newCommentPanel";

export class NewCommentExtension extends ExtensionBase {

    private commentPanel: CommentPanel;
  
    static extensionName = "NewCommentExtension";
   
    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private commentButton: Autodesk.Viewing.UI.Button;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
        this.onModelRootLoaded = this.onModelRootLoaded.bind(this);
       
        this.commentPanel = new CommentPanel(this.viewer, this.viewer.container, "SmartDrawings-Panel-CommentEdit");
    }

    load(): boolean {
        return super.load();
    }

    unload(): boolean {
        return super.unload();
    }

    static registerExtension() {
        super.registerExtension(NewCommentExtension.extensionName, NewCommentExtension);
    }

    onToolbarCreated(): void {

        this.commentButton = UiUtils.createButton({
            id: "SmartDrawings.CommentButton",
            tooltip: "Comments",
            iconClass: "ion-md-quote",
            onClick: () => {
                this.commentPanel.setVisible(!this.commentPanel.isVisible());
            }
        });

        this.subToolbar = this.getControlGroup("SmartDrawings.Extensions");
        this.subToolbar.addControl(this.commentButton);

        this.commentPanel.addVisibilityListener(visible => {
            this.commentButton.setState(visible ? Autodesk.Viewing.UI.Button.State.ACTIVE : Autodesk.Viewing.UI.Button.State.INACTIVE);
        });
    }

    onModelRootLoaded(): void {
    }

    showComments(commentId: string) {
        if (!this.commentPanel.isVisible()) {
            this.commentPanel.setVisible(true, commentId);
        }
    }

    isPanelVisible(): boolean {
        return this.commentPanel.isVisible();
    }
}